<template>
    <pl-dom :value="transferDom">
        <transition :name="transition" @after-leave="afterLeave">
            <div class="link-dialog"
                 :class="classes"
                 v-show="currentValue"
                 :style="styles"
                 @click="p_clickShadow"
                 @mouseenter="pl_mouseenter"
                 @mouseleave="pl_mouseleave">
                <div class="link-dialog-content"
                     ref="content"
                     v-if="p_initialized"
                     @click="p_clickContent"
                     :style="contentStyles">
                    <div class="link-dialog-head" v-if="!noHeader">
                        <div class="link-dialog-title">
                            <span>{{title}}</span>
                        </div>
                        <slot name="headCenter"></slot>
                        <div class="link-dialog-head-operator">
                            <link-icon icon="link-icon-close" @click="p_cancel" class="link-dialog-close-icon" v-if="!noClose"/>
                        </div>
                    </div>
                    <div class="link-dialog-body" :style="bodyStyles">
                        <slot></slot>
                    </div>
                    <div class="link-dialog-foot" :class="[`link-dialog-foot-align-${footAlign}`]" v-if="!noFooter && (cancelButton || confirmButton || $slots.foot|| $slots.footLeft|| $slots.footRight)">
                        <slot name="footLeft"></slot>
                        <slot name="foot">
                            <link-button type="line" :label="cancelButtonText" @click="p_cancel" v-if="!!cancelButton"/>
                            <link-button :label="confirmButtonText" @click="p_confirm" v-if="!!confirmButton"/>
                        </slot>
                        <slot name="footRight"></slot>
                    </div>
                    <link-loading-shadow :value="loading"/>
                </div>
            </div>
        </transition>
    </pl-dom>
</template>

<script>
    import {ValueMixin} from '../mixins';
    import PlIcon from '../icon/link-icon';
    import PlButton from '../button/link-button';
    import keyboard from 'src/utils/keyboard';
    import PlDom from "../dom/pl-dom";

    export default {
        name: "link-dialog",
        components: {PlDom, PlButton, PlIcon},
        mixins: [ValueMixin],
        props: {
            type: {type: String, default: 'info'},                                              //标题类型 info|success|warn|error|help
            title: {type: String, default: () => LinkVue.$t('LinkForm.tips')},                                             //标题
            shape: {type: String, default: 'none'},                                             //形状 none|fillet
            shadowColor: {type: String, default: 'rgba(0,0,0,0.25)'},                           //遮罩层演策
            disabledHideOnClickShadow: {type: Boolean, default: true},                          //是否禁用点击遮罩关闭窗口功能
            transition: {type: String, default: 'link-dialog-animate-drop'},                    //对话框显隐动画
            height: {type: String | Number,},                                                   //对话框内容高度
            minHeight: {type: String | Number},                                                 //对话框内容最小高度
            maxHeight: {type: String | Number},                                                 //对话框内容最大高度
            width: {type: String | Number,},                                                    //对话框内容宽度
            minWidth: {type: String | Number},                                                  //对话框内容最小宽度
            maxWidth: {type: String | Number},                                                  //对话框内容最大宽度
            full: {type: Boolean},                                                              //对话框是否沾满全屏
            confirmButton: {type: Boolean},                                                     //是否带确认按钮
            cancelButton: {type: Boolean},                                                      //是否带取消按钮
            confirmButtonText: {type: String, default: () => LinkVue.$t('global.confirm')},                                 //确认按钮文本
            cancelButtonText: {type: String, default: () => LinkVue.$t('global.cancel')},                                  //取消按钮文本
            noClose: {type: Boolean},                                                           //是否隐藏关闭按钮
            dialogClass: {type: String,},                                                       //由于对话框有可能被移动到body节点下，这里设置对话框class，以便控制样式
            vertical: {type: String, default: 'center'},                                        //对话框纵向位置 start|center|end
            horizontal: {type: String},                                                         //对话框横向位置 start|center|end
            initialized: {type: Boolean,},                                                      //对话框是否初始化的时候就初始化内容，默认为否
            destroyOnHide: {type: Boolean},                                                     //对话框是否在关闭的时候销毁内容
            transferDom: {type: Boolean},                                                       //对话框是否移动到body节点下
            max: {type: Boolean},                                                               //是否可最大化
            noHeader: {type: Boolean},                                                          //不带顶部栏
            noFooter: {type: Boolean},                                                          //不带底部栏
            noPadding: {type: Boolean},                                                         //对话框内容去掉默认内边距
            loading: {type: Boolean},                                                           //对话框内容loading遮罩
            // min: {type: Boolean},
            // remove: {type: Boolean},
            top: {type: Number | String,},                                                      //对话框偏移顶部位置
            bottom: {type: Number | String},                                                    //对话框偏移底部位置
            left: {type: Number | String},                                                      //对话框偏移左边界位置
            right: {type: Number | String},                                                     //对话框偏移右边界位置
            footAlign: {type: String, default: 'center'},                                       //对话框底部对其方式left|center|right
            zIndex: {type: Number, default: 0},                                                 //基础zIndex，在生成时，会自动加上$lv插件的zIndex
            stable: {type: Boolean},                                                            //是否为大小稳定的对话框，是则自动设置对话框中的一些组件样式，比如link-tabs

            enterToConfirm: {type: Boolean, default: true},                                     //是否回车触发confirm事件
            spaceToConfirm: {type: Boolean, default: true},                                     //是否空格触发confirm事件
            escToCancel: {type: Boolean, default: true},                                        //是否Esc触发cancel事件

            disabledHideOnConfirm: {type: Boolean},                                             //禁用触发确认事件之后的关闭弹框动作
            disabledHideOnCancel: {type: Boolean},                                              //禁用触发取消事件之后的关闭弹框动作
        },
        provide() {
            return {
                dialog: this,
            }
        },
        data() {
            const noop = () => null
            return {
                noop,
                afterLeave: noop,
                TYPE: Object.keys(this.$lv.TYPE).reduce((ret, key) => {
                    ret[key] = this.$lv.TYPE[key].icon
                    return ret
                }, {}),
                p_index: 0,
                lv_watchValue: false,
                p_isFull: this.full,
                p_initialized: this.initialized || this.value,

                keyboardListener: {
                    'enter': () => {
                        !this.loading && !!this.enterToConfirm && this.p_confirm()
                    },
                    'space': () => {
                        !this.loading && !!this.spaceToConfirm && this.p_confirm()
                    },
                    'esc': () => {
                        !this.loading && !!this.escToCancel && this.p_cancel()
                    },
                }
            }
        },
        watch: {
            value(val) {
                if (val !== this.currentValue) this.show(val)
            },
        },
        computed: {
            classes() {
                return [
                    {
                        'link-dialog-full-size': this.full || this.p_isFull,
                        'link-dialog-padding': !this.noPadding,
                        'link-dialog-stable': this.stable,
                    },
                    `link-dialog-type-${this.type}`,
                    `link-dialog-shape-${this.shape}`,
                    `link-dialog-vertical-${this.vertical || 'start'}`,
                    `link-dialog-horizontal-${this.horizontal || 'center'}`,
                    this.dialogClass,
                ]
            },
            styles() {
                return {
                    backgroundColor: this.shadowColor,
                    zIndex: this.p_index + this.zIndex,
                }
            },
            bodyStyles() {
                const styles = {};
                ['width', 'height', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight'].forEach(prop => !!this[prop] && (styles[prop] = this.$lv.$utils.unit(this[prop])))
                if (!this.width && !this.minWidth && !this.maxWidth) {
                    styles.minWidth = '336px'
                    styles.maxWidth = '500px'
                }
                if (!this.height && !this.minHeight) styles.minHeight = '88px'
                return styles
            },
            contentStyles() {
                const styles = {}
                styles.top = `${this.top != null ? this.top : !this.vertical && !this.horizontal ? '10vh' : 0}`
                this.left != null && (styles.left = this.$lv.$utils.unit(this.left))
                this.bottom != null && (styles.bottom = this.$lv.$utils.unit(this.bottom))
                this.right != null && (styles.right = this.$lv.$utils.unit(this.right))
                return styles
            },
        },
        mounted() {
        },
        methods: {
            async show(val = true) {
                this.afterLeave = this.noop
                const next = () => {
                    if (!!val) {
                        if (this.currentValue === true) return
                        this.p_index = this.p_getTopIndex()
                        this.currentValue = val
                        this.$emit('open')
                        !!document.activeElement && document.activeElement.blur()
                    } else {
                        if (this.currentValue === false) return;
                        this.hide()
                    }
                }
                if (!this.p_initialized) {
                    this.p_initialized = true
                    await this.$lv.nextTick()
                    next()
                } else {
                    next()
                }
            },
            hide() {
                this.afterLeave = this.noop
                this.currentValue = false
                if (!!this.destroyOnHide) {
                    this.afterLeave = () => {
                        this.p_initialized = false
                    }
                }
            },
            p_clickShadow(e) {
                if (!this.$refs.content.contains(e.target) && !this.loading) {
                    this.$emit('clickShadow', e)
                    if (!this.disabledHideOnClickShadow) {
                        this.p_cancel()
                    }
                }
            },
            p_clickContent(e) {
                this.$emit('clickContent', e)
            },
            p_getTopIndex() {
                return this.$lv.getZIndex()
            },
            p_confirm() {
                this.$emit('confirm')
                !this.disabledHideOnConfirm && this.hide()
            },
            p_cancel() {
                this.$emit('cancel')
                !this.disabledHideOnCancel && this.hide()
            },
            pl_mouseenter() {
                keyboard.addListener(this.keyboardListener)
            },
            pl_mouseleave() {
                keyboard.removeListener(this.keyboardListener)
            },
        },
        beforeDestroy() {
            keyboard.removeListener(this.keyboardListener)
        },
    }
</script>

<style lang="scss">
    @include themeify {
        $head-height: 46px;
        $foot-height: 56px;
        $dialog-types: (
                info:$color-primary,
                warn:$color-warn,
                error:$color-error,
                success:$color-success,
                help:$color-info,
        );
        .link-dialog {
            @include public-style;
            @include transition-all;
            position: fixed;
            left: 0;
            top: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 0;
            transition-duration: 0.5s;

            .link-dialog-content {
                position: relative;
                background-color: white;
                box-shadow: $box-shadow;
                transition: all 500ms cubic-bezier(0.23, 1, 0.32, 1);

                .link-dialog-loading {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    color: $color-primary;
                    font-size: 13px;
                    cursor: progress;

                    .link-icon {
                        margin-bottom: 12px;
                        font-size: 30px;
                    }
                }

                .link-dialog-head, .link-dialog-foot {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 $padding;
                }

                .link-dialog-head {
                    height: $head-height;
                    line-height: $head-height;
                    box-sizing: border-box;
                    font-size: 14px;
                    box-shadow: 0 2px 8px rgba(81, 90, 110, 0.1);

                    .link-dialog-type-icon {
                        margin-right: $padding/2;
                    }

                    .link-dialog-head-operator {
                        color: #6F7788;

                        .link-icon {
                            @include transition-all;
                            cursor: pointer;

                            &:hover {
                                transform: scale(1.3);
                            }

                            &:not(:first-child) {
                                margin-left: 12px;
                            }
                        }
                    }
                }

                .link-dialog-body {
                    box-sizing: border-box;
                    overflow: auto;
                    /*background-color: $dialog-body-background;*/
                }

                .link-dialog-foot {
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;
                    box-shadow: 0 -2px 8px rgba(81, 90, 110, 0.1);
                    height: $foot-height;

                    .link-button:not(:last-child) {
                        margin-right: 12px;
                    }

                    &.link-dialog-foot-align-left {
                        justify-content: flex-start;
                    }

                    &.link-dialog-foot-align-center {
                        justify-content: center;
                    }

                    &.link-dialog-foot-align-right {
                        justify-content: flex-end;
                    }
                }
            }

            &.link-dialog-animate-drop-enter-active, &.link-dialog-animate-drop-leave-active {
                opacity: 1;

                .link-dialog-content {
                    transform: translate3d(0, 0, 0);
                }
            }

            &.link-dialog-animate-drop-enter, &.link-dialog-animate-drop-leave-to {
                opacity: 0;

                .link-dialog-content {
                    transform: translate3d(0, -30px, 0);
                }
            }

            &.link-dialog-scale-enter-active, &.link-dialog-scale-leave-active {
                .link-dialog-content {
                    transform: scale(1);
                }
            }

            &.link-dialog-scale-enter, &.link-dialog-scale-leave-to {
                .link-dialog-content {
                    transform: scale(1.1);
                    opacity: 0;
                }
            }

            @each $key, $value in $list-shape {
                &.link-dialog-shape-#{$key} {
                    .link-dialog-content {
                        border-radius: $value;
                    }
                }
            }

            &.link-dialog-full-size {
                .link-dialog-content {
                    width: 100% !important;
                    height: 100% !important;
                    top: 0 !important;
                    left: 0 !important;
                    bottom: inherit !important;
                    right: inherit !important;
                    display: flex;
                    flex-direction: column;

                    .link-dialog-body {
                        width: 100% !important;
                        max-width: initial !important;
                        flex: 1;
                        overflow: hidden;
                    }
                }
            }

            &.link-dialog-padding {
                .link-dialog-body {
                    padding: $padding;
                    box-sizing: $padding;
                }
            }

            &.link-dialog-horizontal-start {
                justify-content: flex-start;
            }

            &.link-dialog-horizontal-center {
                justify-content: center;
            }

            &.link-dialog-horizontal-end {
                justify-content: flex-end;
            }

            &.link-dialog-vertical-start {
                align-items: flex-start;
            }

            &.link-dialog-vertical-center {
                align-items: center;
            }

            &.link-dialog-vertical-end {
                align-items: flex-end;
            }

            &.link-dialog-stable {
                .lv-render-func {
                    &, & > div {
                        width: 100%;
                        height: 100%;
                    }
                }

                .link-tabs {
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    .link-tabs-body {
                        flex: 1;
                        overflow: hidden;

                        .link-tab {
                            width: 100%;
                            height: 100%;
                            overflow: auto;
                        }
                    }
                }
            }
        }
    }
</style>
